// 选择城市
import React, { useEffect, useState } from "react";
import classnames from "classnames";
import { useHistory } from "react-router-dom";
import useCitiesData from "../store/useCitiesData";
import useSelfArrivalCity from "../store/useSelfArrivalCity";
import useBasicFormData from "../store/useBasicFormData";
import { ProvinceTypes, CityTypes } from "../interfaces/home";
import useBaseInfo from "../store/useBaseInfo";
import { sendReport } from "../../../utils/reporter";
import MessageBox from "../../../components/message-box";
import useHashModal from "../../../hooks/useHashModal";

import "./index.scss";

export default function CityPicker(props) {
  const history = useHistory();
  const { setContentEdited } = useBaseInfo();
  const { data: provincesCitiesData } = useCitiesData();
  const { selfArrivalCity, setSelfArrivalCity } = useSelfArrivalCity();
  const {
    setDatesStoreContentOfDateTab,
    setModifyOrderArriveStoreTime,
    setModifyOrderShopCode,
  } = useBasicFormData();
  const [provinceList] = useState(provincesCitiesData);
  const [cityList, setCityList] = useState<CityTypes[]>([]);
  const [province, setProvince] = useState<ProvinceTypes | null>(null); // 选择的省
  const [city, setCity] = useState<CityTypes | null>(null); // 选择的市
  const [isShowCity, setIsShowCity] = useState(false); // 选择省 还是 市
  const { visible } = useHashModal("#select-cities", {
    title: "选择城市",
    onShow: () => {
      sendReport({
        mcode: "省份点击",
        point: "P11186`B004",
        type: "page",
      });
    }
  });

  useEffect(() => {
    if (!province) return;
    setCityList(province.children);
    setIsShowCity(true);
  }, [province]);

  useEffect(() => {
    // console.log('进入默认选中对应城市逻辑>>> ', provincesCitiesData)
    // console.log('进入默认选中对应城市逻辑>>> ', selfArrivalCity)
    if (
      !(provincesCitiesData && provincesCitiesData.length > 0) ||
      !selfArrivalCity ||
      !selfArrivalCity.cityCode
    )
      return;
    // 进入默认选中对应城市逻辑
    const { cityCode, provinceName, provinceCode } = selfArrivalCity;
    let targetCityList: CityTypes[] = [];

    // 查找省份
    provincesCitiesData.forEach((provinceItem) => {
      if (provinceCode && `${provinceCode}` === provinceItem.value) {
        console.log("找到匹配省份！", provinceItem);
        targetCityList = provinceItem.children;
        setProvince(provinceItem);
      }
      if (
        provinceName &&
        (provinceName === provinceItem.label ||
          provinceItem.label.includes(provinceName))
      ) {
        targetCityList = provinceItem.children;
        setProvince(provinceItem);
      }
    });

    // 查找城市
    targetCityList.forEach((cityItem) => {
      if (`${cityCode}` === cityItem.value) {
        setCity(cityItem);
      }
    });
  }, [selfArrivalCity, provincesCitiesData]);

  const onClickProvince = (item) => {
    setProvince(item);
    setCity(null);
  };

  const onClickCity = (item) => {
    setCity(item);
  };

  const onPickerConfirm = () => {
    if (!city?.value) {
      MessageBox.toast("请选择城市");

      return;
    }

    setSelfArrivalCity({
      cityName: city?.label || "",
      provinceName: province?.label || "",
      cityCode: city?.value || "",
      address: "",
    });
    setDatesStoreContentOfDateTab(null);
    setModifyOrderArriveStoreTime(0);
    setModifyOrderShopCode("");
    setContentEdited(true);

    sendReport({
      mcode: "省份点击",
      point: "P11186`B003",
    });

    history.goBack();
  };

  if (!visible) return null;

  return (
    <div className="city-picker-wrapper">
      <div className="tips-content">仅显示支持预约维保的城市</div>
      <div className="header-field">
        <span
          className={classnames("province-name", {
            "province-selected": !isShowCity,
          })}
          onClick={() => {
            setIsShowCity(false);
          }}
        >
          {province ? province.label : "请选择省份"}
        </span>
        {province?.value && (
          <>
            <span className="rightArrowIcon" />
            <span
              className={classnames("city-name", {
                "city-selected": isShowCity,
              })}
              onClick={() => {
                setIsShowCity(true);
              }}
            >
              {city ? city.label : "请选择城市"}
            </span>
          </>
        )}
      </div>

      <div className="picker-main-content">
        {!isShowCity && (
          <ul className="usc-province-list">
            {provinceList?.map((item) => {
              return (
                <div
                  key={item.value}
                  className={classnames("picker-item", {
                    "picker-item-selected": item.value === province?.value,
                  })}
                  onClick={() => {
                    onClickProvince(item);
                    sendReport({
                      mcode: "省份点击",
                      point: "P11186`B001",
                    });
                  }}
                >
                  {item.label}
                </div>
              );
            })}
          </ul>
        )}
        {isShowCity && (
          <ul className="usc-city-list">
            {cityList &&
              cityList.map((item) => {
                return (
                  <div
                    key={item.value}
                    className={classnames("picker-item", {
                      "picker-item-selected": item.value === city?.value,
                    })}
                    onClick={() => {
                      onClickCity(item);
                      sendReport({
                        mcode: "省份点击",
                        point: "P11186`B002",
                      });
                    }}
                  >
                    {item.label}
                  </div>
                );
              })}
          </ul>
        )}
      </div>
      <div className="action-field">
        <div className="confirm-btn" onClick={onPickerConfirm}>
          确定
        </div>
      </div>
    </div>
  );
}
